(function () {
  // Edit the wording here. The file-type label is derived automatically
  // from the input's `accept` attribute (set in Contact Form 7).
  const TEXT = {
    dragTitle: 'Tekening uploaden',
    dragHint: 'of klik om te bladeren',
    tap: 'Tekening uploaden',
    button: 'Bladeren',
    files: '%d bestanden',
  };

  function acceptLabel(accept) {
    if (!accept) {
      return '';
    }

    return accept
      .split(',')
      .map(function (type) {
        type = type.trim();
        const ext = type.indexOf('/') !== -1 ? type.split('/').pop() : type.replace(/^\./, '');
        return ext.toUpperCase();
      })
      .filter(function (ext) {
        return ext && ext !== '*';
      })
      .join(', ');
  }

  function enhanceFileUpload(input) {
    const zone = input.closest('.wpcf7-form-control-wrap');

    if (!zone || zone.classList.contains('is-upload-enhanced')) {
      return;
    }

    zone.classList.add('is-upload-enhanced');

    const label = acceptLabel(input.getAttribute('accept'));
    const suffix = label ? ' · ' + label : '';

    const ui = document.createElement('div');
    ui.className = 'file-upload';
    ui.innerHTML =
      '<div class="file-upload__info">' +
      '<span class="file-upload__icon" aria-hidden="true"></span>' +
      '<span class="file-upload__text">' +
      '<span class="file-upload__filename"></span>' +
      '<span class="file-upload__label file-upload__label--drag">' +
      TEXT.dragTitle +
      '<small>' +
      TEXT.dragHint +
      suffix +
      '</small>' +
      '</span>' +
      '<span class="file-upload__label file-upload__label--tap">' +
      TEXT.tap +
      suffix +
      '</span>' +
      '</span>' +
      '</div>' +
      '<span class="file-upload__button">' +
      TEXT.button +
      '</span>';
    zone.insertBefore(ui, input);

    const filename = ui.querySelector('.file-upload__filename');

    function syncFileState() {
      const files = input.files;

      if (files && files.length) {
        // More than one name never fits the line; the input's own
        // tooltip still lists them all on hover.
        filename.textContent =
          files.length === 1
            ? files[0].name
            : TEXT.files.replace('%d', files.length);
        zone.classList.add('has-file');
      } else {
        filename.textContent = '';
        zone.classList.remove('has-file');
      }
    }

    input.addEventListener('change', syncFileState);

    const form = input.closest('form');
    if (form) {
      ['reset', 'wpcf7reset', 'wpcf7mailsent'].forEach(function (evt) {
        form.addEventListener(evt, function () {
          window.setTimeout(syncFileState, 0);
        });
      });
    }

    ['dragenter', 'dragover'].forEach(function (evt) {
      input.addEventListener(evt, function () {
        zone.classList.add('is-dragover');
      });
    });

    ['dragleave', 'dragend', 'drop'].forEach(function (evt) {
      input.addEventListener(evt, function () {
        zone.classList.remove('is-dragover');
      });
    });
  }

  function initFileUploads() {
    document.querySelectorAll('.wpcf7-file').forEach(enhanceFileUpload);
  }

  if (document.readyState !== 'loading') {
    initFileUploads();
  } else {
    document.addEventListener('DOMContentLoaded', initFileUploads);
  }

  document.addEventListener('wpcf7mailsent', function (e) {
    const wrapper = e.target.closest('[data-cf7-redirect]');

    if (!wrapper) {
      return;
    }

    const url = wrapper.getAttribute('data-cf7-redirect');

    if (url) {
      window.location.href = url;
    }
  });
})();
